import { render, staticRenderFns } from "./Guideline.vue?vue&type=template&id=287650a6&scoped=true&"
import script from "./Guideline.vue?vue&type=script&lang=js&"
export * from "./Guideline.vue?vue&type=script&lang=js&"
import style0 from "./Guideline.vue?vue&type=style&index=0&id=287650a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287650a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287650a6')) {
      api.createRecord('287650a6', component.options)
    } else {
      api.reload('287650a6', component.options)
    }
    module.hot.accept("./Guideline.vue?vue&type=template&id=287650a6&scoped=true&", function () {
      api.rerender('287650a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/Guideline.vue"
export default component.exports